//Hooks
import { useOrganization } from './use-organization';
import useFetchEmployeeEmails from './use-fetch-employee-emails';
import { useSmac } from './use-smac';

//Helpers
import { isEmailIncludedInDomains } from 'Shared/helpers';

// Apis
import * as accountManagementApi from 'Shared/api/AccountManagement.api';

const useValidateEmployeeEmail = () => {
  const { isPiOrganization, organization } = useOrganization();
  const { hasClassicAccess } = useSmac();

  const isEmailDomainIncludedInPIAllowedList = ({ email }: { email: string }): boolean => {
    return isPiOrganization
      ? isEmailIncludedInDomains({ allowedDomains: organization.pi_allowed_domains, email })
      : true;
  };

  //Selector or API call to get the list of Employees
  const { employeeEmails } = useFetchEmployeeEmails();

  //Check if the email is part of the allowed domains or the list of Employees
  //Do additional check to see if user already exists in PI for legacy company
  const isEmployeeEmailOrValidDomain = async ({ email }: { email: string }) => {
    if (isEmailDomainIncludedInPIAllowedList({ email }) || employeeEmails.includes(email)) {
      return true;
    }

    if (hasClassicAccess) {
      try {
        const response = await accountManagementApi.piUserExists({
          email,
          piCompanyGuid: organization.pi_company_guid,
        });
        //If the user exists in PI then result is true, otherwise false
        return response.data.result;
      } catch (error) {
        return false;
      }
    }
    return false;
  };

  return { isEmployeeEmailOrValidDomain };
};

export default useValidateEmployeeEmail;
